import React from 'react';
function FolderMinus({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M21 18.222c0 .472-.19.924-.527 1.257-.338.334-.796.521-1.273.521H4.8c-.477 0-.935-.187-1.273-.52A1.767 1.767 0 013 18.221V5.778c0-.472.19-.924.527-1.257C3.865 4.187 4.323 4 4.8 4h4.5l1.8 2.667h8.1c.477 0 .935.187 1.273.52.337.334.527.786.527 1.257v9.778zM9 13h6"
      />
    </svg>
  );
}

export default FolderMinus;
